/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PiggyBankIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="piggy-bank"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M15 9.5L15 9.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(133.333)} data-tinysvg-stroke-width="133.333" />
          <path d="M15.5 5.5L15.5 3L11.5 5.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.5 9.5L19.5 9.5C20.052 9.5 20.5 9.948 20.5 10.5L20.5 12.5C20.5 13.052 20.052 13.5 19.5 13.5L18.5 13.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6 17L6 18.75C6 19.716 6.784 20.5 7.75 20.5L8.25 20.5C8.94 20.5 9.5 19.94 9.5 19.25C9.5 18.56 10.06 18 10.75 18L11.25 18C11.94 18 12.5 18.56 12.5 19.25C12.5 19.94 13.06 20.5 13.75 20.5L14.25 20.5C15.216 20.5 16 19.716 16 18.75L16 17" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M15.5 5.5A6.188 6.188 0 0 1 18.5 9.5" data-tinysvg-shape="arc" data-tinysvg-arc="12.471 10.896 6.188 6.188 299.302 346.958 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M18.5 13.5A3.438 3.438 0 0 1 16 17" data-tinysvg-shape="arc" data-tinysvg-arc="15.067 13.691 3.438 3.438 356.82 434.256 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M4 11A1.738 1.738 0 0 1 2.5 8" data-tinysvg-shape="arc" data-tinysvg-arc="3.658 9.296 1.738 1.738 78.634 228.236 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6 17C4.5 15.5 3.84 14.187 4 12C4.111 10.135 4.969 8.394 6.381 7.17C7.793 5.946 9.638 5.344 11.5 5.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
